import { action, withoutPayload, withPayload } from '../../../utility/redux';
import { ItemList, ListParams } from '../../../types/main';
import { Article } from '../../../types/items';
import { DocumentPagesPayload } from '../articles/types/documentPages';

export const setOpenImageInstructionModal = action(
  'SET_OPEN_IMAGE_INSTRUCTION_MODAL',
  withPayload<boolean>(),
);
export const setInlineImageInstruction = action(
  'SET_INLINE_IMAGE_INSTRUCTION',
  withPayload<boolean>(),
);
export const setImageInstructionId = action(
  'SET_IMAGE_INSTRUCTION_ID',
  withPayload<string>(),
);
export const getImageListRequest = action(
  'GET_INSTRUCTION_IMAGE_LIST_REQUEST',
  withPayload<ListParams>(),
);
export const getImageListSuccess = action(
  'GET_INSTRUCTION_IMAGE_LIST_SUCCESS',
  withPayload<ItemList<Article>>(),
);
export const getImageListFail = action(
  'GET_INSTRUCTION_IMAGE_LIST_FAIL',
  withoutPayload,
);

export const setOpenTextInstructionModal = action(
  'SET_OPEN_TEXT_INSTRUCTION_MODAL',
  withPayload<boolean>(),
);
export const setTextInstructionId = action(
  'SET_TEXT_INSTRUCTION_ID',
  withPayload<string>(),
);
export const setTextTextInstruction = action(
  'SET_TEXT_TEXT_INSTRUCTION',
  withPayload<string>(),
);
export const setInlineTextInstruction = action(
  'SET_INLINE_TEXT_INSTRUCTION',
  withPayload<boolean>(),
);

export const setOpenNoteInstructionModal = action(
  'SET_OPEN_NOTE_INSTRUCTION_MODAL',
  withPayload<boolean>(),
);
export const setNoteInstructionId = action(
  'SET_NOTE_INSTRUCTION_ID',
  withPayload<string>(),
);
export const setUrlNoteInstruction = action(
  'SET_URL_NOTE_INSTRUCTION',
  withPayload<string>(),
);
export const setInlineNoteInstruction = action(
  'SET_INLINE_NOTE_INSTRUCTION',
  withPayload<boolean>(),
);

export const setOpenVideoInstructionModal = action(
  'SET_OPEN_VIDEO_INSTRUCTION_MODAL',
  withPayload<boolean>(),
);
export const setInlineVideoInstruction = action(
  'SET_INLINE_VIDEO_INSTRUCTION',
  withPayload<boolean>(),
);
export const setVideoInstructionId = action(
  'SET_VIDEO_INSTRUCTION_ID',
  withPayload<string>(),
);
export const getVideoListRequest = action(
  'GET_INSTRUCTION_VIDEO_LIST_REQUEST',
  withPayload<ListParams>(),
);
export const getVideoListSuccess = action(
  'GET_INSTRUCTION_VIDEO_LIST_SUCCESS',
  withPayload<ItemList<Article>>(),
);
export const getVideoListFail = action(
  'GET_INSTRUCTION_VIDEO_LIST_FAIL',
  withoutPayload,
);

export const setOpenTitleInstructionModal = action(
  'SET_OPEN_TITLE_INSTRUCTION_MODAL',
  withPayload<boolean>(),
);
export const setInlineTitleInstruction = action(
  'SET_INLINE_TITLE_INSTRUCTION',
  withPayload<boolean>(),
);
export const setTitleInstructionId = action(
  'SET_TITLE_INSTRUCTION_ID',
  withPayload<string>(),
);

export const setOpenNameScriptInstructionModal = action(
  'SET_OPEN_NAME_SCRIPT_INSTRUCTION_MODAL',
  withPayload<boolean>(),
);
export const setInlineNameScriptInstruction = action(
  'SET_INLINE_NAME_SCRIPT_INSTRUCTION',
  withPayload<boolean>(),
);
export const setNameScriptInstructionId = action(
  'SET_NAME_SCRIPT_INSTRUCTION_ID',
  withPayload<string>(),
);

export const setOpenWebPageInstructionModal = action(
  'SET_OPEN_WEB_PAGE_INSTRUCTION_MODAL',
  withPayload<boolean>(),
);
export const setInlineWebPageInstruction = action(
  'SET_INLINE_WEB_PAGE_INSTRUCTION',
  withPayload<boolean>(),
);
export const setWebPageInstructionId = action(
  'SET_WEB_PAGE_INSTRUCTION_ID',
  withPayload<string>(),
);

export const setOpenDocumentPageInstructionModal = action(
  'SET_OPEN_DOCUMENT_PAGE_INSTRUCTION_MODAL',
  withPayload<boolean>(),
);
export const setInlineDocumentPageInstruction = action(
  'SET_INLINE_DOCUMENT_PAGE_INSTRUCTION',
  withPayload<boolean>(),
);
export const setDocumentPageInstructionId = action(
  'SET_DOCUMENT_PAGE_INSTRUCTION_ID',
  withPayload<string>(),
);
export const getDocumentListRequest = action(
  'GET_INSTRUCTION_DOCUMENT_LIST_REQUEST',
  withPayload<ListParams>(),
);
export const getDocumentListSuccess = action(
  'GET_INSTRUCTION_DOCUMENT_LIST_SUCCESS',
  withPayload<ItemList<Article>>(),
);
export const getDocumentListFail = action(
  'GET_INSTRUCTION_DOCUMENT_LIST_FAIL',
  withoutPayload,
);
export const getArticleDocumentPagesRequest = action(
  'GET_INSTRUCTION_ARTICLE_DOCUMENT_PAGES_REQUEST',
  withPayload<number>(),
);

export const getArticleDocumentPagesSuccess = action(
  'GET_INSTRUCTION_ARTICLE_DOCUMENT_PAGES_SUCCESS',
  withPayload<DocumentPagesPayload>(),
);

export const getArticleDocumentPagesFail = action(
  'GET_INSTRUCTION_ARTICLE_DOCUMENT_PAGES_FAIL',
  withoutPayload,
);


export const setOpenAudioInstructionModal = action(
  'SET_OPEN_AUDIO_INSTRUCTION_MODAL',
  withPayload<boolean>(),
);
export const setInlineAudioInstruction = action(
  'SET_INLINE_AUDIO_INSTRUCTION',
  withPayload<boolean>(),
);
export const setAudioInstructionId = action(
  'SET_AUDIO_INSTRUCTION_ID',
  withPayload<string>(),
);
export const getAudioListRequest = action(
  'GET_INSTRUCTION_AUDIO_LIST_REQUEST',
  withPayload<ListParams>(),
);
export const getAudioListSuccess = action(
  'GET_INSTRUCTION_AUDIO_LIST_SUCCESS',
  withPayload<ItemList<Article>>(),
);
export const getAudioListFail = action(
  'GET_INSTRUCTION_AUDIO_LIST_FAIL',
  withoutPayload,
);
